import { MyLink } from '@ui-kit/MyLink';
import { ButtonOpenYandexMapTypeProps } from './TypeProps';
import classNames from 'classnames';
import IconMap from './icons/yandexmap.svg';

import styles from './ButtonOpenYandexMap.module.scss';

export const ButtonOpenYandexMap = ({ url, className }: ButtonOpenYandexMapTypeProps) => {
  if (!url) {
    return null;
  }
  return (
    <MyLink href={url} color={'black'} className={classNames(styles.Wrapper, className)}>
      <IconMap />
      Открыть Яндекс.Карты
    </MyLink>
  );
};
